const formatMoney = (amount, currency) => {
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    }).format(amount);
  } catch {
    return `$${amount}`;
  }
};

// Normalises the campaign object that comes with the user
export function getCampaignInfo(campaign) {
  const discount = Number(campaign?.discount_percentage) || 0;
  const months = Number(campaign?.discount_duration_months) || 0;
  const reward = Number(campaign?.reward_amount) || 0;
  const currency = campaign?.reward_currency || 'USD';

  return {
    discount,
    months,
    reward,
    currency,
    discountLabel: discount ? `${discount}%` : '',
    monthsLabel: months ? `${months} months` : '',
    rewardLabel: reward ? formatMoney(reward, currency) : '',
  };
}
